import styles from './_dealer-group-management.module.scss';
import * as ReactDOM from 'react-dom';
import React, { useEffect, useState } from 'react';
import {
  GridExpandChangeEvent,
  GridRowProps,
} from '@progress/kendo-react-grid';



import { filterBy, FilterDescriptor } from '@progress/kendo-data-query';

import { AppState } from '../../../Store/rootReducer';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { DealerGroup } from '../../../Models/DealerGroup';
import { GenericGrid } from '@amsanalytics/react-shared-library';
import DealerGroupDetail from './DealerGroupDetail/DealerGroupDetail';
import DealerGroupEditorDialog from './DealerGroupEditorDialog/DealerGroupEditorDialog';
import { createDealerGroup, loadAllDealerGroups, loadAllDealers, updateDealerGroup } from '../../../Store/Dealers/actions';
import { loadAllDealerReports } from '../../../Store/PerformanceReport/actions';
import { loadModerators } from '../../../Store/Admin/actions';
import { includes } from 'ramda';
import moment from 'moment';
import LoadingPanel from '../../Controls/LoadingPanel/LoadingPanel';
import { setDealerGroupPageLoading } from '../../../Store/Shared/actions';
export interface DealerGroupManagementProps {

}

export default function DealerGroupManagement(props: DealerGroupManagementProps) {
  const dealerGroups = useSelector((state: AppState) => state.dealers.dealerGroups);
  const dealers = useSelector((state: AppState) => state.dealers.dealers);
  const businessTypes = useSelector((state: AppState) => state.library.businessTypes);
  const moderators = useSelector((state: AppState) => state.admin.moderators);
  const dealerReports = useSelector((state: AppState) => state.performanceReport.dealerReports);
  const dealerGroupPageLoading = useSelector((state: AppState) => state.shared.dealerGroupPageLoading);
  const [selectedDealerGroup, setSelectedDealerGroup] = useState<DealerGroup | null>();
  const [dealerGroupsForGrid, setDealerGroupsForGrid] = useState<(DealerGroup & {loading?: boolean, expanded?: boolean})[]>([]);
  const dispatch = useDispatch();
  useEffect(() => {        
    dispatch(setDealerGroupPageLoading(true));
    dispatch(loadAllDealerGroups());
    dispatch(loadAllDealers());
    dispatch(loadModerators());
    dispatch(loadAllDealerReports());
  }, []);


  useEffect(() => {
    if(dealerGroups.length > 0 && dealerReports.length > 0 && dealers.length > 0) {        
      dispatch(setDealerGroupPageLoading(false));
      setDealerGroupsForGrid(dealerGroups.map((dg, index) => {
        return {
          ...dg,
          expanded: (dealerGroupsForGrid.find(dgfg => dgfg.id?.toLowerCase() === dg.id?.toLowerCase()))?.expanded! ?? false,
          updating: false,
          businessTypes: businessTypes.filter(bt => dg.businessTypeIds.includes(bt.id!)).map(bt => bt.name).join(', '),
          createdDate: new Date(dg.createdDate)
        }
      }));
    }
  }, [dealerGroups, dealerReports, dealers, dealerGroupPageLoading]);
  const rowRender = (row: React.ReactElement, props: GridRowProps) => {
    if (props.rowType === 'data') {
      const dealer: (DealerGroup & {updating?: boolean, expanded?: boolean}) = dealerGroupsForGrid.find(d => d.id === props.dataItem.id)!;
      if (dealer.updating) {
        return (
          <React.Fragment>
            {row}
            <tr style={{position: 'relative', height: '0px'}}>
              <td colSpan={4}> {/* Replace 100 with the actual number of columns */}
                <LoadingPanel style={{ position: 'absolute', width: '100%', textAlign: 'center' }} label='Updating' />
              </td>
            </tr>
          </React.Fragment>
        );
      }
      return row;
    }
    return row;
  }
  return (
     <>
      <div className={styles.dealerGroupManagementContainer}>
        <GenericGrid<DealerGroup>
          disableEditing={false}
          disableAdding={false}
          useIconButtons={true}
          itemNameStyle={{ color: '#d95137' }}
          itemName='Dealer Groups'
          disableGrouping={true}
          style={{ display: 'flex', flex: 1, height: '100%' }}
          items={dealerGroupsForGrid.map(dg => {
            const dealersForGroup = dealers.filter(d => includes(dg.id!.toLowerCase(), d.dealerGroupLookupInfoList?.map(dgi => dgi.dealerGroupId.toLowerCase()) ?? []));
            const dealerReportsForGroup = dealerReports.filter(dr => includes(dr.clientId, dealersForGroup.map(dfg => dfg.id)));
            const distinctClientIds = [...new Set(dealerReportsForGroup.map(item => item.clientId))];
            const allSubmitted = dealerReportsForGroup.length > 0 && distinctClientIds.every(clientId =>
              dealerReportsForGroup.some(report =>
                    report.clientId === clientId &&
                    report.status === 'Submitted' &&
                    report.month === moment().month() &&
                    report.year === moment().year()
                )
            );
            return {
              ...dg,
              dataStatus: allSubmitted ? 'Submitted' : 'Pending',
              businessTypeName: businessTypes.filter(bt => dg.businessTypeIds.includes(bt.id!)).map(bt => bt.name).join(', '),
              createdDate: new Date(dg.createdDate)
            }
          }) ?? []}
          onOpenItemEditor={() => {
            setSelectedDealerGroup(null);
          }}
          selectedField={'selected'}
          onItemSelected={(item: DealerGroup) => {
            if (item) {
              setSelectedDealerGroup({
                id: item.id,
                name: item.name,
                description: item.description,
                sortOrder: item.sortOrder,
                moderatorIds: item.moderatorIds,
                businessTypeIds: item.businessTypeIds,
                createdDate: item.createdDate,
              });
            }
          }}
          onItemExpanded={(event: GridExpandChangeEvent) => {
            const updatedDealerGroupsForGrid = dealerGroupsForGrid.map(dg => {
              if (event.dataItem.id === dg.id) {
                return {
                  ...dg,
                  expanded: event.value
                }
              }
              return { ...dg }
            });
            setDealerGroupsForGrid(updatedDealerGroupsForGrid);
          }}
          detail={DealerGroupDetail}
          sortDescriptors={[{ field: 'date', dir: 'desc' }]}
          size="small"
          rowRender={rowRender}
          columns={[
            { field: "name", title: "Name", width: '150px' },
            { field: "description", title: "Description" },
            { field: "businessTypes", width: "130px", title: "Type(s)" },
            { field: "dataStatus", width: "130px", title: "Data Status"},
            { field: "createdDate", title: "Created", format: "{0:d}", preventFiltering: true, width: '110px'}
          ]}
        />
      </div>
      {selectedDealerGroup !== undefined && moderators && (
        <DealerGroupEditorDialog
          dealerGroup={selectedDealerGroup ?? null}
          businessTypes={businessTypes}
          moderators={moderators}
          onCancel={() => setSelectedDealerGroup(undefined)}
          onSubmit={(dealerGroup: DealerGroup) => { 
            if(dealerGroup.id) {
              setDealerGroupsForGrid(dealerGroupsForGrid.map(dg => {
                if (dg.id === dealerGroup.id) {
                  return {
                    ...dg,
                    updating: true
                  }
                }
                return dg;
              }));
              dispatch(updateDealerGroup(dealerGroup));
            } else {
              dispatch(createDealerGroup(dealerGroup));
            }
            setSelectedDealerGroup(undefined);
          }}
        />
      )}
      {dealerGroupPageLoading && <LoadingPanel label={"Loading Dealer Groups..."}  style={{position: 'absolute'}}/>}
    </>
  );
}
